<template>
    <section class="search__field">

        <input type="text"
               v-model="input"
               @focus="activate"
               autocomplete="off"
               @input="loadItems"
               @keydown.down="downItem"
               @keydown.left="focus = 1"
               @keydown.up.prevent="upItem"
               @keydown.right="focus = shown"
               @keydown.esc="visible = false"
               @keydown.enter.prevent="enterItem"
               placeholder="Введите поисковой запрос"
               :class="{ 'search__input': true, 'search__input--loading': isLoading }">

        <div v-show="visible && (notFound || shown)" class="search__dropdown" ref="dropdown">
            <group v-if="group.paginator.total" v-for="group in items" :key="group.alias" :group="group" @group-replenished="groupReplenished"></group>

            <div v-if="notFound" class="p-3">Ничего не найдено :(<br class="d-block d-sm-none"> Попробуйте изменить запрос :)</div>
        </div>

    </section>
</template>

<script>
    import debounce from 'lodash.debounce'

    export default {
        props: {
            route: {
                type: String,
                required: true
            },
            value: {
                type: String,
                required: false
            }
        },

        data() {
            return {
                shown: 0, //количество отображаемых ссылок в выпадающем меню
                focus: 0, //порядковый номер ссылки при навигации вверх/вниз
                items: [], //массив результата загрузки вида [String 'index' => Array listOfItems]
                visible: false, //видимость выпадающего списка
                notFound: false, //сообщение если ничего не найдено
                isLoading: false, //индикатор загрузки
                input: this.value //текстовое поле запроса
            }
        },

        methods: {
            upItem() {
                if (this.focus > 1) {
                    this.focus--
                }
            },

            downItem() {
                if (this.focus <= this.shown) {
                    this.focus++
                }
            },

            enterItem() {
                this.$refs.dropdown.querySelector('.search__dropdown-item--active')?.click()
            },

            activate() {
                if (this.focus < 0) {
                    this.focus = 0
                }

                this.visible = true
            },

            /**
             * Обработчик события подгрузки айтемов
             *
             * @param addedItemsCount количество подгруженных айтемов
             * @param isEnded закончились ли айтемы
             */
            groupReplenished(addedItemsCount, isEnded) {
                this.focus-- //смещаем активный элемент назад на 1 пункт
                this.shown += addedItemsCount //пополняем количество отображаемых айтемов

                if (isEnded) {
                    this.shown-- //если подгружать больше нечего, то вычитаем ссылку на подгрузку
                }
            },

            /**
             * Подсчитываем количество ссылок выпадающего списка
             *
             * @param items
             * @returns {*}
             */
            getShown(items) {
                return Object.keys(items).reduce((total, index) => {
                    let group = items[index],
                        sum = total + group.paginator.to

                    return group.paginator.current_page < group.last_page ? sum + 1 : sum
                }, 0)
            },

            loadItems: debounce(function() { //подгрузка после ввода запроса
                this.shown = 0
                this.items = []
                this.notFound = false

                if (this.input.trim().length > 2) {
                    this.fetchItems(this.route, { term: this.input }).then(response => {
                        this.focus = 0
                        this.visible = true
                        this.items = response
                        this.shown = this.getShown(this.items)

                        if (!this.shown) {
                            this.notFound = true
                        }

                        $app.runEvent('filter', { 'главный поиск': this.input.replace(/(<([^>]+)>)/gi, '') })
                    })
                }
            }, 700),

            fetchItems(route, data = {}) {
                this.isLoading = true

                return $.get(route, data).then(response => {
                    this.isLoading = false

                    return response
                }).fail(() => {
                    this.isLoading = false

                    swal.fire('Ошибка :(', 'Попробуйте повторить запрос', 'error')
                })
            }
        },

        watch: {
            focus(val) {
                this.$refs.dropdown.querySelectorAll('.search__dropdown-item').forEach((item, index) => {
                    item.classList.remove('search__dropdown-item--active')

                    if (val === index + 1) {
                        item.classList.add('search__dropdown-item--active')
                    }
                })
            }
        },

        mounted() {
            this.$el.firstElementChild.form.addEventListener('submit', event => {
                this.loadItems()

                event.preventDefault()
            })

            window.addEventListener('click', event => {
                if (! event.target.closest('#' + this.$el.parentNode.id)) {
                    this.visible = false
                }
            })

            if (this.input && $app.isModerator) {
                this.loadItems()
            }
        },

        components: {
            Group: require('./group').default
        }
    }
</script>